module.exports = __webpack_public_path__ + "static/bg-slider2-security-b672cbc0fb25cccf9873ad25b447c730.jpg";